/* Tice Nits: collectiepagina (filter in stappen, sorteren, kleurbolletjes, gedragen foto, carrousel). Gewone JS, geen bibliotheken. */
(function () {
  'use strict';

  /* ---------- Filter, sorteren, kaarten ---------- */
  function initCollection(root) {
    if (root.__tnc) return;
    var grid = root.querySelector('[data-tnc-grid]');
    if (!grid) return;
    root.__tnc = true;
    // Extra kaarten uit aparte secties (pagina's met meer dan 50 kaarten) komen in dit raster
    Array.prototype.forEach.call(document.querySelectorAll('[data-tnc-extra]'), function (ex) {
      Array.prototype.forEach.call(ex.querySelectorAll('[data-tnc-card]'), function (c) { grid.appendChild(c); });
      ex.hidden = true;
    });
    // Badge "wat komt erop" van die kaarten: naam uit de tegel van stap 1
    Array.prototype.forEach.call(grid.querySelectorAll('[data-tnc-badge]'), function (b) {
      var lb = root.querySelector('[data-tnc-bord="' + b.getAttribute('data-tnc-badge') + '"] .tnc-tile__lb');
      if (lb) { b.textContent = lb.textContent; } else { b.remove(); }
    });
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-tnc-card]'));
    var zelf = grid.querySelector('[data-tnc-zelf]');
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-tnc-bord]'));
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-tnc-model]'));
    var subGroups = Array.prototype.slice.call(root.querySelectorAll('[data-tnc-sub-for]'));
    var subPills = Array.prototype.slice.call(root.querySelectorAll('[data-tnc-subpill]'));
    var sortEl = root.querySelector('[data-tnc-sort]');
    var countEl = root.querySelector('[data-tnc-count]');
    var emptyEl = root.querySelector('[data-tnc-empty]');
    var resetBtns = root.querySelectorAll('[data-tnc-reset]');
    var zelfData = {};
    try { zelfData = JSON.parse(root.querySelector('[data-tnc-zelf-data]').textContent) || {}; } catch (e) {}

    var state = { bord: 'alles', model: 'alle', sub: '', sort: 'populair' };

    function has(list, attr, value) {
      return list.some(function (el) { return el.getAttribute(attr) === value; });
    }

    // Beginstand uit de URL (?personalisatie=lijn&model=hoodie)
    try {
      var qs = new URLSearchParams(window.location.search);
      var qb = qs.get('personalisatie'), qm = qs.get('model');
      if (qb && has(tiles, 'data-tnc-bord', qb)) state.bord = qb;
      if (qm && has(pills, 'data-tnc-model', qm)) state.model = qm;
      var qsub = qs.get('soort');
      if (qsub && has(subPills, 'data-tnc-subpill', qsub)) state.sub = qsub;
    } catch (e) {}

    function priceOf(c) { return parseFloat(c.getAttribute('data-price')) || 0; }
    function newOf(c) { return parseFloat(c.getAttribute('data-new')) || 0; }
    function orderOf(c) { return parseInt(c.getAttribute('data-order'), 10) || 0; }

    function render(updateUrl) {
      /* Zelf ontwerpen: de producten die volledig te personaliseren zijn (data-zelf), elk product één keer */
      var seen = {};
      var visible = cards.filter(function (c) {
        var okM = state.model === 'alle' || (' ' + (c.getAttribute('data-model') || '') + ' ').indexOf(' ' + state.model + ' ') > -1; /* een kaart mag bij meerdere modellen horen: "knuffel deken" */
        var okS = !state.sub || c.getAttribute('data-sub') === state.sub;
        if (state.bord === 'zelf') {
          var h = c.getAttribute('data-handle') || '';
          if (c.getAttribute('data-zelf') !== '1' || !okM || !okS || (h && seen[h])) return false;
          if (h) seen[h] = true;
          return true;
        }
        var okB = state.bord === 'alles' || (' ' + (c.getAttribute('data-bord') || '') + ' ').indexOf(' ' + state.bord + ' ') > -1; /* een kaart mag meerdere personalisaties hebben, gescheiden door een spatie (30 okt) */
        return okB && okM && okS;
      });
      var sorted = visible.slice().sort(function (a, b) {
        if (state.sort === 'prijs-laag') return priceOf(a) - priceOf(b) || orderOf(a) - orderOf(b);
        if (state.sort === 'prijs-hoog') return priceOf(b) - priceOf(a) || orderOf(a) - orderOf(b);
        if (state.sort === 'nieuw') return newOf(b) - newOf(a) || orderOf(a) - orderOf(b);
        return orderOf(a) - orderOf(b);
      });
      cards.forEach(function (c) { c.hidden = visible.indexOf(c) === -1; });
      sorted.forEach(function (c) { grid.appendChild(c); });

      var showZelf = !!zelf && ((state.bord === 'zelf' && visible.length === 0) || (state.bord === 'alles' && state.model !== 'alle'));
      var zData = zelfData[state.sub] || zelfData[state.model] || zelfData.alle || {};
      if (zData.hide) showZelf = false;
      if (zelf) {
        zelf.hidden = !showZelf;
        if (showZelf) {
          var z = zData;
          var t = zelf.querySelector('[data-tnc-zelf-titel]');
          var p = zelf.querySelector('[data-tnc-zelf-prijs]');
          if (t && z.titel) t.textContent = z.titel;
          if (p) p.textContent = z.prijs || '';
          // zonder ingevulde link: naar het eerste product van dit model in het raster
          var zUrl = z.url;
          if (!zUrl && sorted.length) { var fa = sorted[0].querySelector('a[href]'); if (fa) zUrl = fa.getAttribute('href'); }
          if (zUrl) { zelf.setAttribute('href', zUrl); } else { zelf.removeAttribute('href'); }
        }
      }

      tiles.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-tnc-bord') === state.bord ? 'true' : 'false'); });
      pills.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-tnc-model') === state.model ? 'true' : 'false'); });
      subGroups.forEach(function (g) { g.hidden = g.getAttribute('data-tnc-sub-for') !== state.model; });
      subPills.forEach(function (b) { b.setAttribute('aria-pressed', (b.getAttribute('data-tnc-subpill') || '') === state.sub ? 'true' : 'false'); });

      var total = visible.length + (showZelf ? 1 : 0);
      if (countEl) {
        var one = root.getAttribute('data-lbl-one') || '1 product';
        var many = root.getAttribute('data-lbl-many') || '{n} producten';
        countEl.textContent = total === 1 ? one : many.replace('{n}', total);
      }
      if (emptyEl) emptyEl.hidden = !(visible.length === 0 && state.bord !== 'zelf');

      if (updateUrl && window.history && window.history.replaceState) {
        try {
          var u = new URL(window.location.href);
          if (state.bord === 'alles') u.searchParams.delete('personalisatie'); else u.searchParams.set('personalisatie', state.bord);
          if (state.model === 'alle') u.searchParams.delete('model'); else u.searchParams.set('model', state.model);
          if (!state.sub) u.searchParams.delete('soort'); else u.searchParams.set('soort', state.sub);
          window.history.replaceState(null, '', u.toString());
        } catch (e) {}
      }
    }

    tiles.forEach(function (b) {
      b.addEventListener('click', function () { state.bord = b.getAttribute('data-tnc-bord'); render(true); });
    });
    pills.forEach(function (b) {
      b.addEventListener('click', function () { state.model = b.getAttribute('data-tnc-model'); state.sub = ''; render(true); });
    });
    subPills.forEach(function (b) {
      b.addEventListener('click', function () { state.sub = b.getAttribute('data-tnc-subpill') || ''; render(true); });
    });
    if (sortEl) sortEl.addEventListener('change', function () { state.sort = sortEl.value; render(false); });
    Array.prototype.forEach.call(resetBtns, function (b) {
      b.addEventListener('click', function () { state.bord = 'alles'; state.model = 'alle'; state.sub = ''; render(true); });
    });

    /* ---------- Per kaart: kleur kiezen, gedragen foto ---------- */
    function setColor(card, btn) {
      var flat = card.querySelector('.tnc-flat');
      if (flat && btn.getAttribute('data-src')) {
        flat.src = btn.getAttribute('data-src');
        if (btn.getAttribute('data-srcset')) flat.srcset = btn.getAttribute('data-srcset');
        flat.alt = btn.getAttribute('data-alt') || flat.alt;
      }
      var dark = btn.getAttribute('data-dark') === '1';
      card.setAttribute('data-dark', dark ? '1' : '0');
      var mot = card.querySelector('[data-mot-dark]');
      if (mot) {
        var src = dark ? mot.getAttribute('data-mot-dark') : (mot.getAttribute('data-mot-light') || mot.getAttribute('data-mot-dark'));
        if (src) mot.src = src;
      }
      Array.prototype.forEach.call(card.querySelectorAll('.tnc-th'), function (t) {
        t.setAttribute('aria-pressed', t === btn ? 'true' : 'false');
      });
    }

    cards.forEach(function (card) {
      Array.prototype.forEach.call(card.querySelectorAll('.tnc-th'), function (btn) {
        btn.addEventListener('click', function () { setColor(card, btn); });
      });
      var swap = card.querySelector('.tnc-swap');
      if (swap) {
        swap.addEventListener('click', function () {
          var on = card.classList.toggle('is-worn');
          swap.setAttribute('aria-pressed', on ? 'true' : 'false');
          swap.setAttribute('aria-label', on ? (swap.getAttribute('data-label-flat') || '') : (swap.getAttribute('data-label-worn') || ''));
        });
      }
    });

    /* Een foto die niet laadt mag nooit een kapot beeld geven:
       het bolletje verdwijnt, de kaart toont de volgende kleur, of anders het groene weeflabel. */
    grid.addEventListener('error', function (e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG') return;
      var card = img.closest('[data-tnc-card]');
      if (!card) return;
      if (img.classList.contains('tnc-worn')) { img.remove(); var sw = card.querySelector('.tnc-swap'); if (sw) sw.remove(); var pg = card.querySelector('.tnc-pager'); if (pg) pg.remove(); return; }
      if (img.closest('.tnc-th')) { img.closest('.tnc-th').remove(); return; }
      if (!img.classList.contains('tnc-flat')) return;
      var failed = img.getAttribute('src');
      Array.prototype.forEach.call(card.querySelectorAll('.tnc-th'), function (t) {
        if (t.getAttribute('data-src') === failed) t.remove();
      });
      var next = card.querySelector('.tnc-th');
      if (next) { setColor(card, next); return; }
      var shot = card.querySelector('.tnc-shot');
      var mot = card.querySelector('.tnc-mot');
      if (mot) mot.remove();
      img.remove();
      shot.classList.add('tnc-shot--label');
      var label = root.querySelector('template[data-tnc-weef]');
      if (label) shot.appendChild(label.content.cloneNode(true));
    }, true);

    render(false);
  }


  /* ---------- Onze eigen ontwerpen: blokken per reeks ---------- */
  function initReeksen(root) {
    if (root.__tnr) return;
    root.__tnr = true;
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-tnr-groep]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tnc-card]'));
    var reeksPills = Array.prototype.slice.call(root.querySelectorAll('[data-tnr-reeks]'));
    var modelPills = Array.prototype.slice.call(root.querySelectorAll('[data-tnr-model]'));
    var sortEl = root.querySelector('[data-tnr-sort]');
    var countEl = root.querySelector('[data-tnr-count]');
    var emptyEl = root.querySelector('[data-tnr-empty]');
    var state = { reeks: 'alle', model: 'alle', sort: 'populair' };
    function num(c, a) { return parseFloat(c.getAttribute(a)) || 0; }
    function render() {
      var shown = 0;
      groups.forEach(function (g) {
        var list = Array.prototype.slice.call(g.querySelectorAll('[data-tnc-card]'));
        var okG = state.reeks === 'alle' || g.getAttribute('data-tnr-groep') === state.reeks;
        var vis = list.filter(function (c) { return okG && (state.model === 'alle' || (' ' + (c.getAttribute('data-model') || '') + ' ').indexOf(' ' + state.model + ' ') > -1); });
        list.forEach(function (c) { c.hidden = vis.indexOf(c) === -1; });
        vis.slice().sort(function (a, b) {
          if (state.sort === 'prijs-laag') return num(a, 'data-price') - num(b, 'data-price') || num(a, 'data-order') - num(b, 'data-order');
          if (state.sort === 'prijs-hoog') return num(b, 'data-price') - num(a, 'data-price') || num(a, 'data-order') - num(b, 'data-order');
          if (state.sort === 'nieuw') return num(b, 'data-new') - num(a, 'data-new') || num(a, 'data-order') - num(b, 'data-order');
          return num(a, 'data-order') - num(b, 'data-order');
        }).forEach(function (c) { c.parentNode.appendChild(c); });
        g.hidden = vis.length === 0;
        shown += vis.length;
      });
      reeksPills.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-tnr-reeks') === state.reeks ? 'true' : 'false'); });
      modelPills.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-tnr-model') === state.model ? 'true' : 'false'); });
      if (countEl) {
        var one = root.getAttribute('data-lbl-one') || '1 ontwerp';
        var many = root.getAttribute('data-lbl-many') || '{n} ontwerpen';
        countEl.textContent = shown === 1 ? one : many.replace('{n}', shown);
      }
      if (emptyEl) emptyEl.hidden = shown !== 0;
    }
    reeksPills.forEach(function (b) { b.addEventListener('click', function () { state.reeks = b.getAttribute('data-tnr-reeks'); render(); }); });
    modelPills.forEach(function (b) { b.addEventListener('click', function () { state.model = b.getAttribute('data-tnr-model'); render(); }); });
    if (sortEl) sortEl.addEventListener('change', function () { state.sort = sortEl.value; render(); });
    var reset = root.querySelector('[data-tnr-reset]');
    if (reset) reset.addEventListener('click', function () { state.reeks = 'alle'; state.model = 'alle'; render(); });

    cards.forEach(function (card) {
      var swap = card.querySelector('.tnc-swap');
      if (swap) {
        swap.addEventListener('click', function () {
          var on = card.classList.toggle('is-worn');
          swap.setAttribute('aria-pressed', on ? 'true' : 'false');
          swap.setAttribute('aria-label', on ? (swap.getAttribute('data-label-flat') || '') : (swap.getAttribute('data-label-worn') || ''));
        });
      }
    });
    // Een foto die niet laadt: groen weeflabel, nooit een kapot beeld
    root.addEventListener('error', function (e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG') return;
      var card = img.closest('[data-tnc-card]');
      if (!card) return;
      if (img.classList.contains('tnc-worn')) {
        img.remove();
        var sw = card.querySelector('.tnc-swap'); if (sw) sw.remove();
        var pg = card.querySelector('.tnc-pager'); if (pg) pg.remove();
        return;
      }
      if (!img.classList.contains('tnc-flat')) return;
      var shot = card.querySelector('.tnc-shot');
      img.remove();
      shot.classList.add('tnc-shot--label');
      var label = root.querySelector('template[data-tnr-weef]');
      if (label) shot.appendChild(label.content.cloneNode(true));
    }, true);
    render();
  }

  /* ---------- Carrousel "Dit mochten we al maken." ---------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-tnc-track]');
    var prev = root.querySelector('[data-tnc-prev]');
    var next = root.querySelector('[data-tnc-next]');
    if (root.__tnc || !track || !prev || !next) return;
    root.__tnc = true;
    var idx = 0;
    var mq = window.matchMedia('(max-width: 900px)');
    function perView() { return 4; }
    function max() { return Math.max(0, track.children.length - perView()); }
    function apply() {
      if (mq.matches) { track.style.transform = ''; return; }
      var target = track.children[idx];
      track.style.transform = target ? 'translateX(' + (-target.offsetLeft) + 'px)' : '';
      prev.disabled = idx <= 0;
      next.disabled = idx >= max();
    }
    prev.addEventListener('click', function () { idx = Math.max(0, idx - 2); apply(); });
    next.addEventListener('click', function () { idx = Math.min(max(), idx + 2); apply(); });
    window.addEventListener('resize', apply);
    apply();
  }

  /* ---------- Vergelijker foto / tekening ---------- */
  function initCompare(el) {
    if (el.__tnc) return;
    el.__tnc = true;
    var range = el.querySelector('.tnc-cmp__range');
    if (!range) return;
    function set() { el.style.setProperty('--pos', range.value + '%'); }
    range.addEventListener('input', set);
    set();
    if (!el.hasAttribute('data-sway')) return;
    try { if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
    var stop = false, t0 = 0;
    function halt() { stop = true; }
    ['pointerdown', 'touchstart', 'focusin', 'keydown'].forEach(function (ev) { el.addEventListener(ev, halt, { passive: true }); });
    function tick(t) {
      if (stop) return;
      if (!t0) t0 = t;
      range.value = Math.round(50 + 34 * Math.sin((t - t0) / 1000 * 0.8));
      set();
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tnc-cmp]'), initCompare);
    Array.prototype.forEach.call(document.querySelectorAll('[data-tnc]'), initCollection);
    Array.prototype.forEach.call(document.querySelectorAll('[data-tnr]'), initReeksen);
    Array.prototype.forEach.call(document.querySelectorAll('[data-tnc-car]'), initCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
